import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
// import SaasToggler from './SaasToggler';
import LoginButton from './LoginButton';
import DropdwonMenu from './DropdwonMenu';
import logo from '@/assets/logo.svg';
import rkt from '@/assets/rkt.svg';
import ruscomtech_text from '@/assets/ruscomtech_text.svg';
import { useNavbarTheme } from '@/contexts/NavbarThemeContext';

const nav_map = [
  {
    "to": "/technologies",
    "title": "APM Технологии"
  },{
    "to": "/about",
    "title": "О компании"
  },{
    "to": "/mcp",
    "title": "MCP"
  },{
    "to": "/about/#tech-partners",
    "title": "Технологические партнеры"
  },{
    "to": "/cases",
    "title": "Кейсы"
  },{
    "to": "/blog",
    "title": "Блог"
  },{
    "to": "/partners",
    "title": "Партнёрам"
  },{
    "to": "/cenoobrazovanie",
    "title": "Цена"
  },{
    "to": "https://doc.ruscomtech.ru/index.php/Начало_работы_с_Ключ-АСТРОМ",
    "title": "Документация"
  }
]


function Navbar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  const isNewNavbar = useNavbarTheme().theme === 'new';
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const navRef = useRef(null);
  const [navHeight, setNavHeight] = useState(123);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) &&
        !event.target.closest('button[aria-label="Toggle mobile menu"]')) {
        setIsMobileMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Update nav height when it changes
  useEffect(() => {
    if (navRef.current) {
      setNavHeight(navRef.current.offsetHeight);
    }

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === navRef.current) {
          setNavHeight(entry.target.offsetHeight);
        }
      }
    });

    if (navRef.current) {
      resizeObserver.observe(navRef.current);
    }

    return () => {
      if (navRef.current) {
        resizeObserver.unobserve(navRef.current);
      }
    };
  }, []);

  // Close mobile menu when screen size changes to lg or above
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) { // lg breakpoint in Tailwind
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <nav ref={navRef} className={`h-[94px] xl:h-[123px] px-4 sm:px-16 justify-center items-center fixed top-0 left-0 right-0 z-50 ${isNewNavbar ? 'bg-[#001f40]' : 'bg-[linear-gradient(100.29deg,#202020_-1.44%,#36302B_35.77%,#59493B_76.69%,#967558_136.31%,#ECB07C_163.4%)] shadow-[0px_4.038px_117.496px_0px_#52351D]'}`}>
        <div className="container w-full h-full mx-auto flex justify-between items-center ">

          <div className="w-[120px] xl:w-[162px] h-[94px] xl:h-[117px] relative overflow-visible">
            <Link to="/" className="flex items-center h-full w-full relative">

              <div className="absolute w-[46.08px] h-[54.68px] xl:w-[66.91px] xl:h-[78.99px] left-[0px] top-[17.35px] xl:top-[25.06px]" >
                <img src={logo} alt="logo" className="w-full h-full object-contain" />
              </div>
              <div className="absolute w-[53.86px] h-[23.27px] xl:w-[78.20px] xl:h-[33.61px] left-[59px] xl:left-[83.63px] top-[30.44px] xl:top-[43.97px]" >
                <img src={rkt} alt="logo" className="w-full h-full object-contain" />
              </div>
              <div className="absolute w-[52.36px] h-[3.58px] xl:w-[76.02px] xl:h-[5.17px] left-[59px] xl:left-[84.17px] top-[62.89px] xl:top-[90.84px]" >
                <img src={ruscomtech_text} alt="logo" className="w-full h-full object-contain" />
              </div>
            </Link>
          </div>

          {/* Hamburger button for mobile */}
          <div className="w-[50px] text-center overflow-visible xl:hidden focus:outline-none">
            <button
              aria-label="Toggle mobile menu"
              className="xl:hidden focus:outline-none"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? (
                <svg
                  width="37"
                  height="34"
                  viewBox="0 0 37 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {isNewNavbar && (
                    <defs>
                      <linearGradient id="mcpCloseGrad" gradientUnits="userSpaceOnUse" x1="2" y1="2" x2="35" y2="32">
                        <stop offset="0%" stopColor="#e45d59" />
                        <stop offset="100%" stopColor="#7c86c9" />
                      </linearGradient>
                    </defs>
                  )}
                  <path d="M2 2L35 32" stroke={isNewNavbar ? "url(#mcpCloseGrad)" : "#FFD48E"} strokeWidth="4" strokeLinecap="round" />
                  <path d="M2 32L35 2" stroke={isNewNavbar ? "url(#mcpCloseGrad)" : "#FFD48E"} strokeWidth="4" strokeLinecap="round" />
                </svg>
              ) : (
                <svg width="37" height="34" viewBox="0 0 37 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {isNewNavbar && (
                    <defs>
                      <linearGradient id="mcpBurgerGrad" gradientUnits="userSpaceOnUse" x1="2" y1="2" x2="35" y2="32">
                        <stop offset="0%" stopColor="#e45d59" />
                        <stop offset="100%" stopColor="#7c86c9" />
                      </linearGradient>
                    </defs>
                  )}
                  <path d="M2 2H34.8889" stroke={isNewNavbar ? "url(#mcpBurgerGrad)" : "#FFD48E"} strokeWidth="4" strokeLinecap="round" />
                  <path d="M2 17H34.8889" stroke={isNewNavbar ? "url(#mcpBurgerGrad)" : "#FFD48E"} strokeWidth="4" strokeLinecap="round" />
                  <path d="M2 32H34.8889" stroke={isNewNavbar ? "url(#mcpBurgerGrad)" : "#FFD48E"} strokeWidth="4" strokeLinecap="round" />
                </svg>
              )}
            </button>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden xl:flex items-center ">
            <div className="flex items-center gap-5">
              <div className="relative" ref={dropdownRef}>
                <div className="flex items-center">
                  <Link
                    to="/"
                    className={`text-sm font-bold ${isNewNavbar ? "font-inter" : "font-['Open Sans']"} ${isActive('/') ? (isNewNavbar ? 'text-[#e85e57]' : 'text-[#ecb07b]') : (isNewNavbar ? 'text-[#626fb0]' : 'text-white')
                      }`}
                  >
                    Главная
                  </Link>
                  <button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="ml-1 text-white focus:outline-none"
                  >
                    <svg
                      className={`w-4 h-4 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
                      fill={isNewNavbar ? "#626fb0" : "#D1606B"}
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill={isNewNavbar ? "#626fb0" : "#D1606B"}
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                  {isDropdownOpen && (
                    <DropdwonMenu onPress={() => setIsDropdownOpen(false)} />
                  )}
                </div>
              </div>
              {nav_map.map((l, key) => {
                const cls = `text-sm font-bold ${isNewNavbar ? "font-inter" : "font-['Open Sans']"} ${isActive(l.to) ? (isNewNavbar ? 'text-[#e85e57]' : 'text-[#ecb07b]') : (isNewNavbar ? 'text-[#626fb0]' : 'text-white')
                  }`;
                const isExternal = l.to.includes('http');
                if (isExternal) {
                  return (
                    <a
                      key={key}
                      href={l.to}
                      className={cls}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {l.title}
                    </a>
                  );
                }
                return (
                  <Link key={key} to={l.to} className={cls}>
                    {l.title}
                  </Link>
                );
              })}
              {/* <SaasToggler /> */}
              <LoginButton isNewNavbar={isNewNavbar} />
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          ref={mobileMenuRef}
          className={`xl:hidden fixed left-0 right-0 shadow-lg z-40 overflow-y-auto max-h-[calc(100vh-123px)] ${isNewNavbar ? 'bg-[#001f40]' : 'bg-[#36302B]'}`}
          style={{ top: `${navHeight}px` }}
        >
          <div className="px-4 py-6 space-y-4">
            <div className={`border-b pb-4 ${isNewNavbar ? 'border-[#1c3564]' : 'border-gray-700'}`}>
              <div className="flex items-center justify-between">
                <Link
                  to="/"
                  className={`text-base font-bold ${isNewNavbar ? "font-inter" : "font-['Open Sans']"} ${isActive('/') ? (isNewNavbar ? 'text-[#e85e57]' : 'text-[#ecb07b]') : (isNewNavbar ? 'text-[#626fb0]' : 'text-white')}`}
                >
                  Главная
                </Link>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsMobileDropdownOpen(!isMobileDropdownOpen);
                  }}
                  className="text-white focus:outline-none"
                >
                  <svg
                    className={`w-5 h-5 transition-transform ${isMobileDropdownOpen ? 'rotate-180' : ''}`}
                    fill={isNewNavbar ? "#626fb0" : "#D1606B"}
                    viewBox="0 0 20 20"
                  >
                    <path
                      fill={isNewNavbar ? "#626fb0" : "#D1606B"}
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
              {isMobileDropdownOpen && (
                <DropdwonMenu />
              )}
            </div>
              
            {nav_map.map((l, key) => {
                const cls = `block text-base font-bold ${isNewNavbar ? "font-inter" : "font-['Open Sans']"} py-2 ${isActive(l.to) ? (isNewNavbar ? 'text-[#e85e57]' : 'text-[#ecb07b]') : (isNewNavbar ? 'text-[#626fb0]' : 'text-white')
                  }`;
                const isExternal = l.to.includes('http');
                if (isExternal) {
                  return (
                    <a
                      key={key}
                      href={l.to}
                      className={cls}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      {l.title}
                    </a>
                  );
                }
                return (
                  <Link
                    key={key}
                    to={l.to}
                    className={cls}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {l.title}
                  </Link>
                );
              })}
              <div className={`pt-[20px] border-t ${isNewNavbar ? 'border-[#1c3564]' : 'border-gray-700'}`}>
                {/* <SaasToggler /> */}
              </div>
              <LoginButton isNewNavbar={isNewNavbar} />
          </div>
        </div>
      )}

      <div className={`w-full overflow-hidden h-[90px] xl:h-[123px] ${isNewNavbar ? 'bg-[#001f40]' : 'bg-white'}`}></div>
    </>
  );
}

export default Navbar; 